import { RoundShareIconButton } from 'src/app/shared/components/share';
import type { RoundShareIconButtonConfig } from 'src/app/shared/components/share';

type Props = {
	buttonConfigs: readonly RoundShareIconButtonConfig[];
};

export const InlineShareChannelsCarousel: React.FC<Props> = ({ buttonConfigs }) => {
	return (
		<div className="relative mt-7">
			<div
				data-testid="inline-share-channels-carousel-fade"
				className="pointer-events-none absolute inset-y-0 -right-px z-1 w-10 bg-gradient-to-l from-white to-transparent"
			/>
			<div
				data-testid="inline-share-channels-carousel-scroller"
				className="flex min-w-0 flex-1 snap-x gap-0 overflow-x-auto overscroll-contain py-1 ps-2 pe-4 [--webkit-overflow-scrolling:touch] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
			>
				{buttonConfigs.map((buttonConfig) => (
					<div key={buttonConfig.channel} className="w-20 max-w-20 shrink-0 snap-start">
						{/* TODO: the nested selectors are necessary to override the icon size to match experiment design, if productized, we
						    need to update the DS icon sizes for social sharing icons */}
						<RoundShareIconButton
							buttonConfig={buttonConfig}
							className="w-20 max-w-20 text-center [&_[data-variant='body']]:block [&_[data-variant='body']]:truncate [&>*:first-child]:h-10 [&>*:first-child]:w-10 [&>*:first-child>*:first-child]:h-10 [&>*:first-child>*:first-child]:w-10"
							data-qa={`psf-promote-or-share-inline-${buttonConfig.channel}-button`}
						/>
					</div>
				))}
			</div>
		</div>
	);
};
